import { createContext } from "react"

const HQContext = createContext({})
const FarmContext = createContext({})

export { HQContext, FarmContext }
